module.exports = __webpack_public_path__ + "img/fuwutuan.3ae0478.png";